import { useMemo } from 'react';
import { useVisibleJobs } from '../../utils';

export function useAmountSalaries() {
  const visibleJobs = useVisibleJobs();

  return useMemo(
    () =>
      visibleJobs
        .map(({ salary }) => salary)
        .filter(({ type }) => !['none', 'custom'].includes(type)),
    [visibleJobs]
  );
}
